<app-auth-container
	label="Log in"
	description="Welcome to Closer"
	submitButtonText="Log In"
	[hideSubmitButton]="
		(currloginScreen | async) !== LoginScreen.USE_EXISTING_ACCOUNT
	"
	[hideSocials]="true"
	[loading]="(isLoading$ | async) || (authIsLoading$ | async)"
	[formGroup]="authForm"
	[disabled]="(isLoading$ | async) || (authIsLoading$ | async)"
	(onFormSubmit)="onFormSubmit()"
>
	<ng-container form-content>
		<div
			*ngIf="(currloginScreen | async) === LoginScreen.USE_EXISTING_ACCOUNT"
			class="mt-12 min-w-80"
		>
			<app-input
				class="font-light"
				label="Email"
				[formControlName]="USER_CREDENTIALS.EMAIL"
				type="email"
			></app-input>

			<fieldset class="flex flex-col">
				<app-input
					class="font-light"
					label="Password"
					[formControlName]="USER_CREDENTIALS.PASSWORD"
					type="password"
					class="mt-3"
				></app-input>
				<app-anchor type="static" [url]="forgetUrl"
					>Forgot password?</app-anchor
				>
			</fieldset>
		</div>
	</ng-container>

	<ng-container footer-content>
		<div
			*ngIf="(currloginScreen | async) === LoginScreen.CHOOSE_LOGIN_METHOD"
			class="mt-32"
		>
			<ui-button
				label="I'm new to Closer"
				(click)="createNewAccount()"
				color="primary"
				class="w-full"
				classes="w-full"
			></ui-button>
			<p class="mt-3 mx-2 font-normal text-sm text-center">
				We’ll create an account with your LEAP details.
			</p>
			<div
				class="grid grid-cols-[1fr_auto_1fr] grid-rows-[1fr_1fr] w-full py-8"
			>
				<div class="border-b border-grey-lighter"></div>
				<div class="row-span-2 flex justify-center items-center">
					<span class="px-3">OR</span>
				</div>
				<div class="border-b border-grey-lighter"></div>
			</div>
			<ui-button
				label="I have a Closer account"
				(click)="goToUseExistingAccountScreen()"
				color="secondary"
				class="w-full"
				classes="w-full"
			></ui-button>
		</div>

		<div
			*ngIf="(currloginScreen | async) === LoginScreen.USE_EXISTING_ACCOUNT"
			class="w-full -mt-8"
		>
			<ui-button
				label="Back"
				(click)="goToChooseLoginMethodScreen()"
				[style]="'ghost'"
				color="secondary"
				class="w-full"
				classes="w-full"
				[disabled]="(isLoading$ | async) || (authIsLoading$ | async)"
			></ui-button>
		</div>
	</ng-container>
</app-auth-container>
